<template>
  <div class="modal skin-modal accept-offer-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../assets/close.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b v-if="!ibanFormVisible">{{ $t('Contact information') }}</b>
                <b v-else>{{ $t('IBAN transfer') }}</b>
              </div>

              <!-- Step 1: Contact Information -->
              <div class="form-fields-wrapper" v-if="!ibanFormVisible">
                <label>
                  <div class="desc">{{ $t('Name') }}:</div>
                  <input type="text" :placeholder="$t('Name')" v-model="name" />
                </label>
                <label>
                  <div class="desc">{{ $t('Surname') }}:</div>
                  <input type="text" :placeholder="$t('Surname')" v-model="surname" />
                </label>
                <label>
                  <div class="desc">{{ $t('E-mail') }}:</div>
                  <input type="email" :placeholder="$t('E-mail address')" v-model="email" />
                </label>
                <label>
                  <div class="desc">{{ $t('Phone') }}:</div>
                  <input type="tel" :placeholder="$t('Phone')" v-model="phone" />
                </label>
                <label>
                  <div class="desc">{{ $t('Country') }}:</div>
                  <select v-model="country" class="select">
                    <option disabled value="">{{ $t('Country') }}</option>
                    <option v-for="(item, i) in countryOptions" :key="i" :value="item">
                      {{ item.title }}
                    </option>
                  </select>
                </label>
                <label>
                  <div class="desc">{{ $t('City') }}:</div>
                  <input type="text" :placeholder="$t('City')" v-model="city" />
                </label>
                <label>
                  <div class="desc">{{ $t('Address') }}:</div>
                  <input type="text" :placeholder="$t('Address')" v-model="address" />
                </label>
                <label>
                  <div class="desc">{{ $t('Post code') }}:</div>
                  <input type="text" :placeholder="$t('Post code')" v-model="postCode" />
                </label>

                <div class="buttons buttons-special">
                  <button 
                    v-if="$parent.payoutMethods && $parent.payoutMethods.card"
                    class="button" 
                    :class="{ disabled: !contactFieldsAreFilled }" 
                    @click="handleCardPayout"
                  >
                    <span>{{ $t('Pay with card') }}</span>
                  </button>
                  <button
                    v-if="$parent.payoutMethods && $parent.payoutMethods.sepa"
                    class="button"
                    :class="{ disabled: !contactFieldsAreFilled }"
                    @click="showIbanForm"
                  >
                    <span>{{ $t('Continue with IBAN') }}</span>
                  </button>
                </div>
              </div>

              <!-- Step 2: IBAN Details -->
              <div class="form-fields-wrapper" v-else>
                <label>
                  <div class="desc">{{ $t('First name') }}:</div>
                  <input type="text" :placeholder="$t('First name')" v-model="bank_holder_name" />
                </label>
                <label>
                  <div class="desc">{{ $t('Last name') }}:</div>
                  <input type="text" :placeholder="$t('Last name')" v-model="bank_holder_surname" />
                </label>
                <label>
                  <div class="desc">{{ $t('IBAN') }}:</div>
                  <input type="text" maxlength="34" :placeholder="$t('IBAN')" v-model="iban_number" />
                </label>
                <div class="cta-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input type="checkbox" v-model="terms" />
                      <div class="checkbox"></div>
                      <span class="title">{{ $t('I agree with') }} </span>
                      <router-link v-if="privacyPolicyLink" :to="privacyPolicyLink" class="title">
                        {{ $t('privacy policy') }}
                      </router-link>
                      <span class="title" v-else>{{ $t('privacy policy') }}</span>
                      <span class="title"> {{ $t('and') }} </span>
                      <router-link v-if="termsConditionsLink" :to="termsConditionsLink" class="title">
                        {{ $t('terms and conditions') }}
                      </router-link>
                      <span class="title" v-else>{{ $t('terms and conditions') }}</span>
                    </div>
                  </label>
                </div>
                <div class="buttons buttons-special">
                  <button class="button back-btn" @click="ibanFormVisible = false">
                    <span>{{ $t('Back') }}</span>
                  </button>
                  <button class="button" :class="{ disabled: !sepaFieldsAreFilled }" @click="handleSepaPayout">
                    <span>{{ $t('Confirm payout') }}</span>
                  </button>
                </div>
              </div>

              <transition name="slide">
                <div v-if="errorMessage" class="error-desc desc red">
                  {{ errorMessage }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AcceptOfferModal',
  props: {
    orderToView: {
      type: Object,
      default: () => ({}),
    },
    errorMessage: {
      type: String,
      default: '',
    },
    privacyUrl: {
      type: [Object, String],
      default: null,
    },
    termsUrl: {
      type: [Object, String],
      default: null,
    },
  },
  data() {
    return {
      ibanFormVisible: false,
      email: '',
      name: '',
      surname: '',
      phone: '',
      country: '',
      city: '',
      address: '',
      postCode: '',
      terms: false,
      countryOptions: [],
      iban_number: '',
      bank_holder_name: '',
      bank_holder_surname: '',
      isLoading: false,
    };
  },
  computed: {
    contactFieldsAreFilled() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    sepaFieldsAreFilled() {
      return (
        this.iban_number &&
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.terms
      );
    },
    privacyPolicyLink() {
      return this.privacyUrl || null;
    },
    termsConditionsLink() {
      return this.termsUrl || null;
    },
  },
  watch: {
    orderToView: {
      handler() {
        this.resetState();
      },
      immediate: true,
    },
    errorMessage(newVal) {
      if (!newVal) {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getCountries();
    this.prefillUserProfile();
  },
  methods: {
    resetState() {
      this.ibanFormVisible = false;
      this.terms = false;
      this.iban_number = '';
      this.bank_holder_name = '';
      this.bank_holder_surname = '';
      this.isLoading = false;
    },
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + 'countries')
        .then((res) => {
          this.countryOptions = res.data.payload || [];
        })
        .catch(() => {
          this.countryOptions = [];
        });
    },
    prefillUserProfile() {
      this.$http
        .get(process.env.VUE_APP_API + 'user/profile')
        .then((res) => {
          this.email = res.data.email || '';
          this.name = res.data.name || '';
          this.surname = res.data.surname || '';
          this.phone = res.data.phone || '';
          this.city = res.data.city || '';
          this.address = res.data.address || '';
          this.postCode = res.data.post_code || '';
        })
        .catch(() => {});
    },
    showIbanForm() {
      if (!this.contactFieldsAreFilled) return;
      this.$emit('setError', '');
      this.ibanFormVisible = true;
    },
    handleApiError(error) {
      let message = 'An unknown error occurred.';
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          const firstKey = Object.keys(error.response.data.errors)[0];
          const firstError = error.response.data.errors[firstKey];
          if (Array.isArray(firstError)) {
            message = firstError[0];
          }
        } else if (error.response.data.message) {
          message = error.response.data.message;
        }
      }
      this.isLoading = false;
      this.$emit('setError', message);
    },
    handleCardPayout() {
      if (!this.contactFieldsAreFilled || this.isLoading) return;
      this.isLoading = true;
      this.$emit('setError', '');

      const payload = {
        id: this.orderToView.id,
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country?.iso,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        currency: this.orderToView.currency,
      };

      this.$http
        .post(process.env.VUE_APP_API + 'offer/request-payout/card', payload)
        .then((res) => {
          this.isLoading = false;
          if (res.data.status === 'OK' && res.data.redirect_url) {
            this.$emit('refreshOffers');
            window.location.href = res.data.redirect_url;
          } else {
            this.$emit('setError', res.data.message || 'Could not initiate card payout.');
          }
        })
        .catch((error) => this.handleApiError(error));
    },
    handleSepaPayout() {
      if (!this.sepaFieldsAreFilled || this.isLoading) return;
      this.isLoading = true;
      this.$emit('setError', '');

      const payload = {
        id: this.orderToView.id,
        account_number: this.iban_number,
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
      };

      this.$http
        .post(process.env.VUE_APP_API + 'offer/request-payout/sepa', payload)
        .then((res) => {
          this.isLoading = false;
          if (res.data.status === 'OK') {
            this.$emit('refreshOffers');
            this.close();
            this.$router.push({ path: '/offer-accepted-succes' });
          } else {
            this.$emit('setError', res.data.message || 'Could not submit payout request.');
          }
        })
        .catch((error) => this.handleApiError(error));
    },
    close() {
      this.$emit('setError', '');
      this.$emit('closeAcceptOfferModal');
    },
  },
};
</script>

<style scoped>
.accept-offer-modal label {
  display: block;
}

.accept-offer-modal label .desc {
  display: block;
  width: 100%;
}

.accept-offer-modal label input {
  width: 100%;
  margin-top: 8px;
}

.accept-offer-modal .select {
  width: 100%;
  display: block;
  margin-top: 8px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding: 15px 48px 15px 22px;
  border: 0;
  border-radius: 6px;
  background-color: #F0F2F3;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #363D47;
  outline: 0;
}

.accept-offer-modal .buttons-special {
  display: flex;
  gap: 16px;
  margin-top: 46px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.accept-offer-modal .buttons-special .button {
  width: auto !important;
  flex-shrink: 0;
  flex-grow: 0;
}

.accept-offer-modal .back-btn {
  background: transparent;
  border: 2px solid #363D47;
  color: #363D47;
  padding: 12px 42px;
  box-shadow: none;
}

.accept-offer-modal .back-btn:hover {
  background: #363D47;
  color: #fff;
  opacity: 1;
}

.accept-offer-modal .back-btn.disabled {
  background: transparent;
  border: 2px solid #D6DAEA;
  color: #D6DAEA;
}

@media screen and (max-width: 768px) {
  .accept-offer-modal .buttons-special {
    flex-direction: column;
    align-items: stretch;
  }
  
  .accept-offer-modal .buttons-special .button {
    width: 100%;
  }
}

.error-desc {
  margin-top: 16px;
}
</style>
